export default __webpack_public_path__ + "static/media/testimonials_cards.2410a060.png";